import React, { useEffect, useState } from 'react';
import { deleteSss, getAllSSSs } from '../services/sssService';
import { EditIcon } from '../assets/icons';
import CreateSssModal from '../components/UserModals/CreateSssModal';
import EditSssModal from '../components/UserModals/EditSssModal';
import ActionButton from '../components/common/ActionButton';

const Sss = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getAllSSSs();
      setUsers(data);
    } catch (error) {
      console.error('Failed to fetch users:', error);
      setError('Kullanıcı listesi yüklenirken bir hata oluştu.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditModalOpen(true);
  };

  const handleDelete = async (user) => {
      setIsLoading(true);
      setError(null);
  
      try {
       var dd= await deleteSss(user.id);
        // Update the user's status in the local state
        if(dd==1){
          setUsers(prevUsers => 
            prevUsers.map(u => 
              u.id === user.id 
                ? { ...u, aktifMi: !u.aktifMi }
                : u
            )
          );
          window.location.reload()
        }else{
          alert("Gruba kayıtlı personelleri silmeden silemezsiniz.")
        }
       
      } catch (error) {
        setError('Kullanıcı durumu güncellenirken bir hata oluştu.');
        console.error('User status update error:', error);
      } finally {
        setIsLoading(false);
      }
  };

  const handleCreateSuccess = (newUser) => {
    setUsers(prevUsers => [...prevUsers, newUser]);
  };

  const handleEditSuccess = (updatedUser) => {
    setUsers(prevUsers => 
      prevUsers.map(user => 
        user.id === updatedUser.id ? updatedUser : user
      )
    );
  };

  if (isLoading) {
    return (
      <div className="people-container">
        <h1 className="page-title">Kayıtlı Sss</h1>
        <div className="loading">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="people-container">
        <h1 className="page-title">Kayıtlı Sss</h1>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="people-container">
      <h1 className="page-title">Kayıtlı Sss</h1>
      <div className='add-and-search-container'>
        <ActionButton 
          title="Yeni Kayıt Ekle"
          onClick={() => setCreateModalOpen(true)}
        />
        {/* <div className='search-container'>
          <input type='text' placeholder='Kişi ismini yazınız.' />
          <select name='order' id='order'>
                <option value='asc'>Artan</option>
                <option value='desc'>Azalan</option>
            </select>
        </div> */}
      </div>
      <div className="table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>Soru</th>
              <th>Cevap</th>
             <th>Sıra</th>
             
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.soru}</td>
                <td>{user.cevap}</td>
                <td>{user.sira}</td>             
                
                <td className="actions">
                  <button 
                    className="icon-button edit"
                    onClick={() => handleEdit(user)}
                    title="Düzenle"
                  >
                    Düzenle
                    <EditIcon color='black' />
                  </button>
                  <button 
                    className={`icon-button status ${user.aktifMi ? 'active' : 'passive'}`}
                    onClick={() => handleDelete(user)}
                    title={user.aktifMi ? 'Sil' : 'Sil'}
                  >
                    <div className="status-indicator">
                      {user.aktifMi ? 'Sil' : 'Sil'}
                      <input 
                        type="radio" 
                        checked={user.aktifMi} 
                        readOnly 
                      />
                    </div>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <style jsx>{`
       .people-container .users-table .actions .icon-button {
              gap: 0px;
              width: auto;
          }
      `}</style>
      <CreateSssModal 
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />

      {selectedUser && (
        <>
          <EditSssModal
            isOpen={editModalOpen}
            onClose={() => {
              setEditModalOpen(false);
              setSelectedUser(null);
            }}
            user={selectedUser}
            onSuccess={handleEditSuccess}
          />
        </>
      )}
    </div>
  );
};

export default Sss;
